export const DEFAULT_SPOOL_WEIGHT_GRAMS = 1000;

export const MAX_SPOOL_BATCH_QUANTITY = 100;

/**
 * Share of the spool still available, clamped to 0-100 for display. A negative
 * balance means the registration is out of date, and the bar shows empty.
 */
export function remainingPercent(currentWeight, spoolWeight) {
    const spool = Number(spoolWeight) || 0;
    const current = Number(currentWeight) || 0;
    if (spool <= 0) {
        return 0;
    }
    return Math.max(0, Math.min(100, (current / spool) * 100));
}

export function stockSeverity(currentWeight, spoolWeight) {
    const current = Number(currentWeight) || 0;
    if (current <= 0) {
        return 'error';
    }
    const percent = remainingPercent(currentWeight, spoolWeight);
    if (percent <= 10) {
        return 'error';
    }
    if (percent <= 25) {
        return 'warning';
    }
    return 'primary';
}

export function formatGrams(grams) {
    const value = Number(grams);
    if (!Number.isFinite(value)) {
        return '0 g';
    }
    return `${Math.round(value).toLocaleString('pt-BR')} g`;
}

/** Human readable name of a spool, used in selects and history lists. */
export function filamentLabel(filament) {
    if (!filament) {
        return '';
    }
    const parts = [filament.type, filament.brand, filament.color_label]
        .map((part) => String(part || '').trim())
        .filter(Boolean);
    return parts.join(' · ');
}

/** Groups spools by type, brand and colour, which is the farm view of stock. */
export function groupKey(filament) {
    if (!filament) {
        return '';
    }
    return [filament.type, filament.brand, filament.color_label, filament.color]
        .map((part) => String(part || '').trim().toLowerCase())
        .join('|');
}

export function isFilamentDepleted(filament) {
    return (Number(filament?.current_weight) || 0) <= 0;
}

/** Quantos carretéis o indicador de estoque baixo mostra no máximo. */
export const LOW_STOCK_LIMIT = 12;

export const DEFAULT_FILAMENT_SORT_BY = 'created_at';
export const DEFAULT_FILAMENT_SORT_ORDER = 'desc';

/** Fração máxima restante para entrar no painel de estoque baixo. */
export const LOW_STOCK_PERCENT_THRESHOLD = 20;

/**
 * Carretel que pede atenção no painel: menos de 20% do carretel ou sem saldo.
 * A barra da listagem usa outros cortes de cor; aqui o critério é só para o destaque.
 */
export function isLowStock(filament) {
    const current = Number(filament?.current_weight) || 0;
    if (current <= 0) {
        return true;
    }
    return remainingPercent(current, filament?.spool_weight) < LOW_STOCK_PERCENT_THRESHOLD;
}

/**
 * Carretéis com menos saldo primeiro. A ordem é pela fração restante, e não pelos
 * gramas, para que um carretel pequeno quase no fim não fique atrás de um de 1 kg
 * que ainda tem folga.
 */
export function sortByLowestStock(filaments) {
    return [...(filaments || [])].sort((a, b) => {
        const byPercent = remainingPercent(a.current_weight, a.spool_weight)
            - remainingPercent(b.current_weight, b.spool_weight);
        if (byPercent !== 0) {
            return byPercent;
        }
        return (Number(a.current_weight) || 0) - (Number(b.current_weight) || 0);
    });
}
